{
  "$comment": "Сгенерировано frontend/scripts/build-ai-surface.mjs (npm run ai-surface:build). Правится не здесь, а в src/ai-surface/pages.ts и разметке страниц (data-ai-region).",
  "version": 2,
  "pages": [
    {
      "id": "login",
      "path": "/login",
      "title": "Вход",
      "nav": "service",
      "regions": []
    },
    {
      "id": "savedReport",
      "path": "/reports/:ref",
      "title": "Сохранённый отчёт",
      "nav": "service",
      "regions": []
    },
    {
      "id": "canonActors",
      "path": "/actors",
      "title": "Реестр хозяйств (канон)",
      "nav": "data",
      "regions": []
    },
    {
      "id": "canonActor",
      "path": "/actors/:actorId",
      "title": "Карточка субъекта (канон)",
      "nav": "data",
      "regions": []
    },
    {
      "id": "canonAgrocycle",
      "path": "/agrocycle",
      "title": "Агроциклы (канон)",
      "nav": "data",
      "regions": []
    },
    {
      "id": "canonCampaigns",
      "path": "/campaigns",
      "title": "Ход кампаний (канон)",
      "nav": "data",
      "regions": []
    },
    {
      "id": "canonSituations",
      "path": "/situations",
      "title": "Ситуации (канон)",
      "nav": "data",
      "regions": []
    },
    {
      "id": "canonVerification",
      "path": "/verification",
      "title": "Проверка (канон)",
      "nav": "data",
      "regions": []
    },
    {
      "id": "canonFarmWorks",
      "path": "/my-works",
      "title": "Что от меня ждут (канон)",
      "nav": "data",
      "regions": []
    },
    {
      "id": "canonWork",
      "path": "/works/:workId",
      "title": "Карточка работы (канон)",
      "nav": "data",
      "regions": []
    },
    {
      "id": "home",
      "path": "/",
      "title": "Обзор района",
      "nav": "menu",
      "regions": [
        {
          "id": "scope",
          "title": "Цикл · Массив · Печать"
        },
        {
          "id": "now",
          "title": "Сейчас в районе"
        },
        {
          "id": "problems",
          "title": "Где нужно разобраться"
        },
        {
          "id": "lenses",
          "title": "Вкладки «Где нужно разобраться»"
        },
        {
          "id": "situations",
          "title": "Список хозяйств и разбор"
        },
        {
          "id": "evidence",
          "title": "Разбор хозяйства"
        },
        {
          "id": "directions",
          "title": "Направления хозяйства"
        },
        {
          "id": "action",
          "title": "Поручить уточнение"
        },
        {
          "id": "kpi",
          "title": "Пять показателей"
        },
        {
          "id": "insights",
          "title": "Находки"
        },
        {
          "id": "season",
          "title": "Ход работ сезона"
        },
        {
          "id": "pace",
          "title": "Темп кампании"
        },
        {
          "id": "assignments",
          "title": "От решения к результату"
        },
        {
          "id": "farms",
          "title": "Хозяйства: после срока"
        },
        {
          "id": "sources",
          "title": "Работы цикла по источнику"
        }
      ]
    },
    {
      "id": "district",
      "path": "/district",
      "title": "Обзор района (временный адрес)",
      "nav": "legacy",
      "regions": [
        {
          "id": "action",
          "title": "action"
        },
        {
          "id": "assignments",
          "title": "assignments"
        },
        {
          "id": "directions",
          "title": "directions"
        },
        {
          "id": "evidence",
          "title": "evidence"
        },
        {
          "id": "farms",
          "title": "farms"
        },
        {
          "id": "insights",
          "title": "insights"
        },
        {
          "id": "kpi",
          "title": "kpi"
        },
        {
          "id": "lenses",
          "title": "lenses"
        },
        {
          "id": "now",
          "title": "now"
        },
        {
          "id": "pace",
          "title": "pace"
        },
        {
          "id": "problems",
          "title": "problems"
        },
        {
          "id": "scope",
          "title": "scope"
        },
        {
          "id": "season",
          "title": "season"
        },
        {
          "id": "situations",
          "title": "situations"
        },
        {
          "id": "sources",
          "title": "sources"
        }
      ]
    },
    {
      "id": "season",
      "path": "/season",
      "title": "Картина сезона (прежняя главная)",
      "nav": "legacy",
      "regions": [
        {
          "id": "action",
          "title": "action"
        },
        {
          "id": "control",
          "title": "control"
        },
        {
          "id": "evidence",
          "title": "evidence"
        },
        {
          "id": "scope",
          "title": "scope"
        },
        {
          "id": "situations",
          "title": "situations"
        },
        {
          "id": "stages",
          "title": "stages"
        }
      ]
    },
    {
      "id": "guide",
      "path": "/guide",
      "title": "Практика работы",
      "nav": "menu",
      "regions": [
        {
          "id": "guide-intro",
          "title": "Рабочий маршрут руководителя"
        },
        {
          "id": "workday",
          "title": "Руководитель: начало рабочего дня"
        },
        {
          "id": "screens",
          "title": "Какой экран отвечает на ваш вопрос"
        },
        {
          "id": "numbers",
          "title": "Как связаны цифры"
        },
        {
          "id": "limits",
          "title": "Границы текущей версии"
        }
      ]
    },
    {
      "id": "overview",
      "path": "/overview",
      "title": "Реестр района",
      "nav": "data",
      "regions": []
    },
    {
      "id": "cycles",
      "path": "/cycles",
      "title": "Агроциклы",
      "nav": "menu",
      "regions": [
        {
          "id": "hub-summary",
          "title": "Сводка агроциклов"
        },
        {
          "id": "hub-started",
          "title": "Идут сейчас"
        },
        {
          "id": "hub-upcoming",
          "title": "Предстоящие"
        },
        {
          "id": "hub-finished",
          "title": "Закрытые"
        },
        {
          "id": "hub-create",
          "title": "Создать агроцикл"
        }
      ]
    },
    {
      "id": "cycle",
      "path": "/cycles/:id",
      "title": "Агроцикл",
      "nav": "deep",
      "regions": [
        {
          "id": "scope",
          "title": "Выбор агроцикла"
        },
        {
          "id": "upcoming",
          "title": "Скоро"
        },
        {
          "id": "cycle-head",
          "title": "Шапка агроцикла"
        },
        {
          "id": "cycle-facts",
          "title": "Факты агроцикла"
        },
        {
          "id": "sources",
          "title": "Работы по источнику"
        },
        {
          "id": "timeline",
          "title": "План и ход агроцикла"
        },
        {
          "id": "prescriptions",
          "title": "Предписания цикла"
        },
        {
          "id": "works",
          "title": "Работы агроцикла и карта"
        }
      ]
    },
    {
      "id": "work",
      "path": "/cycles/:id/works/:workId",
      "title": "Работа цикла",
      "nav": "deep",
      "regions": [
        {
          "id": "work-actions",
          "title": "Решения по кампании"
        },
        {
          "id": "scope",
          "title": "Контекст анализа"
        },
        {
          "id": "progress",
          "title": "Ход работы"
        },
        {
          "id": "map",
          "title": "Карта работы: контуры по статусу"
        },
        {
          "id": "farms",
          "title": "Хозяйства по статусу"
        },
        {
          "id": "pace",
          "title": "Ход работы по дням"
        },
        {
          "id": "next-step",
          "title": "Следующий шаг по этой работе"
        },
        {
          "id": "water",
          "title": "Вода полива"
        },
        {
          "id": "detail",
          "title": "Полив: подача по хозяйствам и каналам"
        }
      ]
    },
    {
      "id": "template",
      "path": "/templates/:id",
      "title": "Шаблон агроцикла",
      "nav": "deep",
      "regions": [
        {
          "id": "facts",
          "title": "Шапка шаблона"
        },
        {
          "id": "notes",
          "title": "Оговорки источников"
        },
        {
          "id": "stages",
          "title": "Стадии шаблона"
        },
        {
          "id": "editor",
          "title": "Панель правки"
        }
      ]
    },
    {
      "id": "map",
      "path": "/map",
      "title": "Карта",
      "nav": "menu",
      "regions": [
        {
          "id": "map",
          "title": "Карта"
        },
        {
          "id": "layer-pick",
          "title": "Раскрасить по работе / Полив"
        }
      ]
    },
    {
      "id": "farms",
      "path": "/farms",
      "title": "Хозяйства",
      "nav": "menu",
      "regions": [
        {
          "id": "kpi",
          "title": "Четыре числа"
        },
        {
          "id": "map",
          "title": "Земля хозяйств на карте"
        },
        {
          "id": "list",
          "title": "Хозяйства (список)"
        },
        {
          "id": "strip",
          "title": "Культуры по площади · Готовность данных"
        },
        {
          "id": "table",
          "title": "Реестр хозяйств / Хозяйства цикла"
        }
      ]
    },
    {
      "id": "farm",
      "path": "/farms/:id",
      "title": "Хозяйство",
      "nav": "deep",
      "regions": [
        {
          "id": "tabs",
          "title": "Разделы кабинета хозяйства"
        },
        {
          "id": "now",
          "title": "Сейчас"
        },
        {
          "id": "season-results",
          "title": "Межсезонье: итоги и подготовка"
        },
        {
          "id": "attention-quarantine",
          "title": "Требует внимания: карантин"
        },
        {
          "id": "attention-deadlines",
          "title": "Требует внимания: сроки"
        },
        {
          "id": "attention-water",
          "title": "Требует внимания: вода"
        },
        {
          "id": "attention-conflicts",
          "title": "Требует внимания: расхождения"
        },
        {
          "id": "all-clear",
          "title": "Всё в порядке"
        },
        {
          "id": "indicators",
          "title": "Ключевые показатели"
        },
        {
          "id": "harvest-summary",
          "title": "Сдача урожая"
        },
        {
          "id": "land",
          "title": "Земля, поля и агроциклы"
        },
        {
          "id": "directions",
          "title": "Культуры по годам агроцикла"
        },
        {
          "id": "map",
          "title": "Карта хозяйства"
        },
        {
          "id": "assignments",
          "title": "Поручения по хозяйству"
        },
        {
          "id": "history",
          "title": "Прошлые агроциклы"
        },
        {
          "id": "similar",
          "title": "Похожие хозяйства"
        },
        {
          "id": "cycles",
          "title": "Агроциклы хозяйства"
        },
        {
          "id": "cycle-plan",
          "title": "Что поручено хозяйству в цикле"
        },
        {
          "id": "cycle-works",
          "title": "Работы хозяйства и карта"
        },
        {
          "id": "water",
          "title": "Вода хозяйства по поливам"
        },
        {
          "id": "water-kpi",
          "title": "Вода цикла: KPI"
        },
        {
          "id": "water-waterings",
          "title": "Поливы цикла: лента и выбранный полив"
        },
        {
          "id": "water-feed",
          "title": "Лента поливов"
        },
        {
          "id": "water-detail",
          "title": "Выбранный полив: карта, легенда, каналы, контуры"
        },
        {
          "id": "water-chart",
          "title": "Подано по поливам"
        },
        {
          "id": "water-filters",
          "title": "Выбор цикла воды"
        },
        {
          "id": "water-weeks",
          "title": "Вода по неделям"
        },
        {
          "id": "water-requests",
          "title": "Заявки на воду (запасная ветка)"
        },
        {
          "id": "quarantine",
          "title": "Карантин хозяйства: KPI"
        },
        {
          "id": "quarantine-prescriptions",
          "title": "Предписания хозяйства (виджет)"
        },
        {
          "id": "quarantine-map",
          "title": "Карта карантина хозяйства"
        },
        {
          "id": "quarantine-hotspots",
          "title": "Очаги и предписания"
        },
        {
          "id": "quarantine-months",
          "title": "Карантин по месяцам"
        },
        {
          "id": "quarantine-findings",
          "title": "Находки, предписания и сроки"
        },
        {
          "id": "quarantine-events",
          "title": "Смена статусов"
        },
        {
          "id": "harvest",
          "title": "Сдача урожая (вкладка)"
        },
        {
          "id": "contours",
          "title": "Контуры хозяйства"
        },
        {
          "id": "inspection",
          "title": "Агроинспекция и техника"
        }
      ]
    },
    {
      "id": "massif",
      "path": "/massifs/:id",
      "title": "Массив",
      "nav": "deep",
      "regions": [
        {
          "id": "kpi",
          "title": "Показатели массива"
        },
        {
          "id": "campaigns",
          "title": "Идущие кампании массива"
        },
        {
          "id": "farms",
          "title": "Хозяйства массива"
        },
        {
          "id": "map",
          "title": "Массив на карте"
        }
      ]
    },
    {
      "id": "contours",
      "path": "/contours",
      "title": "Контуры",
      "nav": "menu",
      "regions": [
        {
          "id": "kpi",
          "title": "Четыре показателя"
        },
        {
          "id": "filters",
          "title": "Фильтры реестра"
        },
        {
          "id": "table",
          "title": "Таблица контуров"
        },
        {
          "id": "map",
          "title": "Карта контуров"
        }
      ]
    },
    {
      "id": "contour",
      "path": "/contours/:id",
      "title": "Контур",
      "nav": "deep",
      "regions": [
        {
          "id": "tabs",
          "title": "Разделы карточки контура"
        },
        {
          "id": "now",
          "title": "Сейчас"
        },
        {
          "id": "attention-quarantine",
          "title": "Карантин требует внимания"
        },
        {
          "id": "attention-works",
          "title": "Работы после срока"
        },
        {
          "id": "attention-water",
          "title": "Вода: недоподача"
        },
        {
          "id": "all-clear",
          "title": "Активных проблем нет"
        },
        {
          "id": "passport-summary",
          "title": "Паспорт (кратко)"
        },
        {
          "id": "map",
          "title": "Контур и соседи на карте"
        },
        {
          "id": "passport",
          "title": "Паспорт контура"
        },
        {
          "id": "land-users",
          "title": "Землепользователи по датам"
        },
        {
          "id": "areas",
          "title": "Площади по категориям"
        },
        {
          "id": "crops",
          "title": "История культур по сезонам"
        },
        {
          "id": "works",
          "title": "Работы по сезонам"
        },
        {
          "id": "quarantine",
          "title": "Карантин контура"
        },
        {
          "id": "quarantine-map",
          "title": "Контур и соседи: карантин"
        },
        {
          "id": "quarantine-history",
          "title": "Статусы во времени"
        },
        {
          "id": "quarantine-part",
          "title": "Поражённая часть и случай"
        },
        {
          "id": "quarantine-requirements",
          "title": "Предписания контура и история случаев"
        },
        {
          "id": "quarantine-inspections",
          "title": "Последние обследования"
        },
        {
          "id": "water",
          "title": "Поливы контура"
        },
        {
          "id": "water-filters",
          "title": "Выбор цикла воды"
        },
        {
          "id": "water-kpi",
          "title": "Вода цикла на контуре: KPI"
        },
        {
          "id": "water-waterings",
          "title": "Поливы цикла на контуре"
        },
        {
          "id": "water-feed",
          "title": "Лента поливов"
        },
        {
          "id": "water-detail",
          "title": "Выбранный полив на карте"
        },
        {
          "id": "water-chart",
          "title": "Подано по поливам"
        }
      ]
    },
    {
      "id": "water",
      "path": "/water",
      "title": "Вода",
      "nav": "menu",
      "regions": [
        {
          "id": "where",
          "title": "Где разобраться"
        },
        {
          "id": "reference",
          "title": "Справка: каналы и вода вне плана"
        },
        {
          "id": "filters",
          "title": "Агроцикл · Массив"
        },
        {
          "id": "kpi",
          "title": "Четыре показателя"
        },
        {
          "id": "feed",
          "title": "Поливы цикла"
        },
        {
          "id": "detail",
          "title": "Выбранный полив"
        },
        {
          "id": "shortfall",
          "title": "Недоподача и перерасход по хозяйствам"
        },
        {
          "id": "mismatches",
          "title": "Расхождения сверки по поливам"
        },
        {
          "id": "journal",
          "title": "Журнал заявок на воду"
        }
      ]
    },
    {
      "id": "equipment",
      "path": "/equipment",
      "title": "Техника",
      "nav": "legacy",
      "regions": []
    },
    {
      "id": "quarantine",
      "path": "/quarantine",
      "title": "Карантин",
      "nav": "menu",
      "regions": [
        {
          "id": "kpi",
          "title": "Показатели карантина"
        },
        {
          "id": "queue",
          "title": "Очередь решений"
        },
        {
          "id": "coverage",
          "title": "Охват текущего окна профилактики"
        },
        {
          "id": "tabs",
          "title": "Разделы карантина"
        },
        {
          "id": "map",
          "title": "Карта очагов"
        },
        {
          "id": "farms",
          "title": "Хозяйства с очагами"
        },
        {
          "id": "waves",
          "title": "Охват профилактикой (волны обхода)"
        },
        {
          "id": "prescriptions",
          "title": "Предписания карантина"
        },
        {
          "id": "catalog",
          "title": "Официальный перечень видов"
        }
      ]
    },
    {
      "id": "analyst",
      "path": "/analytics",
      "title": "Аналитик",
      "nav": "menu",
      "regions": [
        {
          "id": "ready-questions",
          "title": "Готовые вопросы"
        },
        {
          "id": "free-question",
          "title": "Спросить своими словами"
        },
        {
          "id": "cycle-share",
          "title": "Текущий агроцикл"
        },
        {
          "id": "answer",
          "title": "Ответ по выбранному вопросу"
        },
        {
          "id": "analyst-ask",
          "title": "Действия под ответом"
        },
        {
          "id": "ask-ai",
          "title": "Спросить ИИ с этим контекстом"
        },
        {
          "id": "answer-journal",
          "title": "Журнал заданных вопросов"
        }
      ]
    },
    {
      "id": "waterLedger",
      "path": "/analysis/water",
      "title": "Подробно о воде",
      "nav": "deep",
      "regions": [
        {
          "id": "water",
          "title": "Подробно о воде"
        },
        {
          "id": "volume",
          "title": "Показатели цикла"
        },
        {
          "id": "reconcile",
          "title": "Сверка итога «Подано воды»"
        },
        {
          "id": "waterings",
          "title": "Поливы цикла"
        },
        {
          "id": "canals",
          "title": "Каналы → хозяйства"
        },
        {
          "id": "no-delivery",
          "title": "Где разобраться: земля без подачи"
        },
        {
          "id": "weeks",
          "title": "Динамика по неделям"
        },
        {
          "id": "outside",
          "title": "Вне плана и вне цикла"
        }
      ]
    },
    {
      "id": "planning",
      "path": "/planning",
      "title": "Планирование ресурсов",
      "nav": "legacy",
      "regions": [
        {
          "id": "plan-window",
          "title": "Что потребуется"
        },
        {
          "id": "plan-conditions",
          "title": "Допущения"
        },
        {
          "id": "plan-balance",
          "title": "Что берётся из системы"
        }
      ]
    },
    {
      "id": "briefing",
      "path": "/reports/briefing",
      "title": "К совещанию",
      "nav": "legacy",
      "regions": [
        {
          "id": "control",
          "title": "control"
        },
        {
          "id": "scope",
          "title": "scope"
        }
      ]
    },
    {
      "id": "explore",
      "path": "/explore",
      "title": "ИИ-аналитика (прежняя)",
      "nav": "legacy",
      "regions": []
    },
    {
      "id": "compare",
      "path": "/compare",
      "title": "Сравнение хозяйств",
      "nav": "deep",
      "regions": [
        {
          "id": "pickers",
          "title": "Хозяйство слева / справа"
        },
        {
          "id": "facts",
          "title": "Факты бок о бок"
        },
        {
          "id": "howto",
          "title": "Как читать это сравнение"
        }
      ]
    },
    {
      "id": "pakhtaGalla",
      "path": "/reports/pakhta-galla",
      "title": "Пахта-ғалла: баланс размещения",
      "nav": "legacy",
      "regions": []
    },
    {
      "id": "myToday",
      "path": "/my/today",
      "title": "Сегодня (кабинет хозяйства)",
      "nav": "menu",
      "regions": [
        {
          "id": "today-answer",
          "title": "Что от вас ждут"
        },
        {
          "id": "today-open",
          "title": "Агроциклы хозяйства"
        },
        {
          "id": "today-quarantine",
          "title": "Предписания: отметить «обработали»"
        },
        {
          "id": "today-prescriptions",
          "title": "Работы по предписаниям: источник и срок"
        },
        {
          "id": "today-soon",
          "title": "Скоро"
        },
        {
          "id": "farm-irrigations",
          "title": "Поливы по файлу ирригации"
        },
        {
          "id": "today-silent",
          "title": "Прошлые сезоны"
        }
      ]
    },
    {
      "id": "myFields",
      "path": "/my/fields",
      "title": "Мои поля",
      "nav": "menu",
      "regions": [
        {
          "id": "fields-kpi",
          "title": "Показатели земли"
        },
        {
          "id": "fields-map",
          "title": "Земля хозяйства на карте"
        },
        {
          "id": "fields-table",
          "title": "Поля хозяйства"
        }
      ]
    },
    {
      "id": "myReport",
      "path": "/my/report/:cycleId/:workId",
      "title": "Отчёт по работе",
      "nav": "deep",
      "regions": [
        {
          "id": "report-steps",
          "title": "Шаги отчёта"
        },
        {
          "id": "report-contours",
          "title": "Поля этой работы"
        },
        {
          "id": "report-confirm",
          "title": "Что войдёт в отчёт"
        },
        {
          "id": "report-result",
          "title": "Результат"
        }
      ]
    },
    {
      "id": "myHistory",
      "path": "/my/history",
      "title": "Отчёты хозяйства",
      "nav": "menu",
      "regions": [
        {
          "id": "history-summary",
          "title": "Сводка записей"
        },
        {
          "id": "history-conflicts",
          "title": "Расхождения"
        },
        {
          "id": "history-timeline",
          "title": "Хронология"
        }
      ]
    },
    {
      "id": "opsAssignments",
      "path": "/ops/assignments",
      "title": "Поручения",
      "nav": "menu",
      "regions": [
        {
          "id": "assignment",
          "title": "Поручения"
        },
        {
          "id": "assignment-steps",
          "title": "Четыре шага"
        },
        {
          "id": "assignment-form",
          "title": "Новое поручение"
        },
        {
          "id": "assignment-list",
          "title": "Список поручений"
        }
      ]
    },
    {
      "id": "opsVerify",
      "path": "/ops/verify",
      "title": "Проверка отчётов",
      "nav": "menu",
      "regions": [
        {
          "id": "verify-kpi",
          "title": "Очередь в цифрах"
        },
        {
          "id": "verify-filters",
          "title": "Фильтры очереди"
        },
        {
          "id": "verify-queue",
          "title": "Очередь"
        },
        {
          "id": "verify-howto",
          "title": "Что делает это суждение"
        }
      ]
    },
    {
      "id": "opsCampaigns",
      "path": "/ops/campaigns",
      "title": "Кампании",
      "nav": "menu",
      "regions": [
        {
          "id": "campaigns-cycle",
          "title": "Выбранный агроцикл"
        },
        {
          "id": "campaigns-works",
          "title": "Готовы к запуску"
        },
        {
          "id": "campaigns-list",
          "title": "Идут и закрытые"
        },
        {
          "id": "campaigns-upcoming",
          "title": "Скоро"
        }
      ]
    },
    {
      "id": "opsEntry",
      "path": "/ops/entry",
      "title": "Ввод за хозяйство",
      "nav": "menu",
      "regions": [
        {
          "id": "entry-steps",
          "title": "Шаги ввода"
        },
        {
          "id": "entry-farm",
          "title": "За какое хозяйство"
        },
        {
          "id": "entry-work",
          "title": "По какой работе"
        },
        {
          "id": "entry-report",
          "title": "Отчёт и авторство"
        }
      ]
    },
    {
      "id": "opsTemplates",
      "path": "/ops/templates",
      "title": "Шаблоны культур",
      "nav": "menu",
      "regions": [
        {
          "id": "template-list",
          "title": "Шаблоны культур"
        },
        {
          "id": "template-create",
          "title": "Создать шаблон культуры"
        },
        {
          "id": "template-stages",
          "title": "План шаблона"
        },
        {
          "id": "template-work-form",
          "title": "Форма работы шаблона"
        },
        {
          "id": "template-calendar",
          "title": "Шкала плана"
        },
        {
          "id": "template-changes",
          "title": "Журнал правок"
        }
      ]
    },
    {
      "id": "opsPlacement",
      "path": "/ops/placement",
      "title": "Размещение",
      "nav": "menu",
      "regions": [
        {
          "id": "placement-kpis",
          "title": "Земля по культурам"
        },
        {
          "id": "placement-table",
          "title": "Таблица размещения сезона"
        },
        {
          "id": "placement-conflicts",
          "title": "Ошибки данных: размещение и землепользование расходятся"
        }
      ]
    },
    {
      "id": "opsWater",
      "path": "/ops/water",
      "title": "Загрузка файла ирригации",
      "nav": "menu",
      "regions": [
        {
          "id": "water-steps",
          "title": "Путь файла"
        },
        {
          "id": "upload",
          "title": "Загрузка файла"
        },
        {
          "id": "version",
          "title": "Проверка и разбор"
        },
        {
          "id": "history",
          "title": "История версий"
        },
        {
          "id": "review",
          "title": "Неоднозначные поливы"
        },
        {
          "id": "disputes",
          "title": "Споры фермеров"
        }
      ]
    },
    {
      "id": "opsQuarantine",
      "path": "/ops/quarantine",
      "title": "Ввод карантина",
      "nav": "menu",
      "regions": [
        {
          "id": "desk",
          "title": "Рабочее место карантина"
        },
        {
          "id": "desk-tabs",
          "title": "Вкладки очередей"
        }
      ]
    },
    {
      "id": "dataRegistry",
      "path": "/registry",
      "title": "Источники данных (что вошло в канон)",
      "nav": "data",
      "regions": [
        {
          "id": "registry-balance",
          "title": "Принятый срез и сверка площадей"
        },
        {
          "id": "registry-counts",
          "title": "Четыре числа состава"
        },
        {
          "id": "registry-composition",
          "title": "Из чего собран канон"
        },
        {
          "id": "registry-issues",
          "title": "Что в данных не сходится"
        }
      ]
    },
    {
      "id": "dataQuality",
      "path": "/data-quality",
      "title": "Качество данных",
      "nav": "data",
      "regions": [
        {
          "id": "quality-facets",
          "title": "Разрезы замечаний"
        },
        {
          "id": "quality-filters",
          "title": "Фильтры замечаний"
        },
        {
          "id": "quality-issues",
          "title": "Замечания по группам"
        }
      ]
    },
    {
      "id": "dataMap",
      "path": "/data-map",
      "title": "Карта базы района",
      "nav": "data",
      "regions": [
        {
          "id": "map-canvas",
          "title": "Полотно карты"
        },
        {
          "id": "map-controls",
          "title": "Панель слоёв"
        },
        {
          "id": "map-frame-list",
          "title": "Контуры в кадре"
        },
        {
          "id": "map-coverage",
          "title": "Покрытие карты"
        },
        {
          "id": "map-coverage-table",
          "title": "Покрытие карты (таблица)"
        },
        {
          "id": "map-no-geometry",
          "title": "Контуры без принятой геометрии"
        }
      ]
    },
    {
      "id": "notFound",
      "path": "*",
      "title": "Страница не найдена",
      "nav": "service",
      "regions": []
    }
  ]
}
